import React, { useEffect, useMemo , useState } from 'react';
import { motion , AnimatePresence} from 'framer-motion';
import { projects } from '../utiles/constant';
import { useLocation, useNavigate } from 'react-router-dom';
// import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';

function CaseStudy() {
  const [visibleCount, setVisibleCount] = useState(6);
  const [filter, setFilter] = useState('all');
  const [selectedSkill, setSelectedSkill] = useState(['All']);
  const [startIndex, setStartIndex] = useState(0);   // skill pagination state

  const navigate = useNavigate();
  const location = useLocation();
  const skills = [
    'All',
    'React',
    'React Native',
    'Next.js',
    'Node.js',
    'TypeScript',
    'DevOps',
    'Cloud',
    'Firebase',
    'MongoDB',
    'GitLab',
    'Nest'
  ];

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const filterFromUrl = queryParams.get('filter') || 'all'; 
    setFilter(filterFromUrl);
  }, [location]);

 

const filteredProjects = useMemo(() => {
  if (filter === 'skill') {
    if (selectedSkill.includes('All')) return projects; 
    
    const seen = new Set();
    const ordered = [];

    selectedSkill.forEach((skill) => {
      projects.forEach((project) => {
        if (!seen.has(project.id) && project.languages?.includes(skill)) {
          ordered.push(project);
          seen.add(project.id);
        }
      });
    });

    return ordered;
  }

  if (filter === 'all') return projects;
  return projects.filter((p) => p.category === filter);
}, [filter, selectedSkill]);



  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setSelectedSkill(['All']); 
    navigate(`?filter=${newFilter}`);

  
  };

// multiple skill show in pagination code

const PAGE_SIZE = 5;
const otherSkills = skills.filter((skill) => skill !== 'All');

// const reOrderSkills = [
//   ...otherSkills.filter((s) => selectedSkill.includes(s)),
//   ...otherSkills.filter((s) => !selectedSkill.includes(s)),
// ];

const visibleOtherSkills = otherSkills.slice(startIndex, startIndex + PAGE_SIZE);
const visibleSkills = ['All', ...visibleOtherSkills];

// skill handler
const handleSkillClick = (skill, _) => {
  if (skill === 'All') {
    setSelectedSkill(['All']);
    setStartIndex(0);
    return;
  } else {
    setSelectedSkill((prev) => {
      const withoutAll = prev.filter((s) => s !== 'All'); 

      if (withoutAll.includes(skill)) {
     
        const updated = withoutAll.filter((s) => s !== skill);
        return updated.length === 0 ? ['All'] : updated; 
      } else {

        return [...withoutAll, skill]; 
      }
      
    });
  }
  //  setStartIndex(0);
};
const goPrev = () => {
  setStartIndex((prev) => Math.max(0, prev - PAGE_SIZE));
};

const goNext = () => {
  setStartIndex((prev) =>
    Math.min(otherSkills.length - PAGE_SIZE, prev + PAGE_SIZE)
  );
};

  const handleProjectClick = (id) => {
    navigate(`/case-studies/${id}`); 
  };

  const contentVariants = {
    hidden: { opacity: 0, y: 80 },
    visible: { opacity: 1, y: 0 },
  };

  const textVariants = {
    hidden: { opacity: 0, y: -60 },
    visible: { opacity: 1, y: 0 },
  };

  const handleLoadMore = () => {
    setVisibleCount(prevCount => prevCount + 6);
  };

  return (
    <div className="p-4 md:p-8 lg:px-16 xl:px-32 font-poppins">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={textVariants}
        transition={{ duration: 2, ease: 'easeOut' }}
        className='flex flex-col items-center justify-center text-center mb-10 mt-8'
      >
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-primary">Case Study</h1>
        <p className="mt-4 text-sm sm:text-base md:text-base max-w-2xl text-gray-500">
          Here you will find a collection of projects I have worked on Each project showcases my expertise and innovation.
        </p>
      </motion.div>
      <div className="flex overflow-x-auto hide-scrollbar mb-8 px-4 gap-2 justify-start sm:justify-start md:justify-start lg:justify-center">
        {[
          { id: 'all', label: 'Most Popular' },
          { id: 'mobile-app', label: 'Mobile Apps (Android & IOS)' },
          { id: 'web-app', label: 'Hybrid Web & Mobile Applications' },
          { id: 'website', label: 'Website/Dashboards' },
          { id: 'skill', label: 'Tech Stack' }
        ].map((item) => (
          <button
            key={item.id}
            className={`px-4 h-8 sm:h-10 rounded-md text-xs sm:text-sm whitespace-nowrap ${filter === item.id ? 'bg-primary text-white' : 'bg-gray-200 text-black'
              }`}
            onClick={() => handleFilterChange(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>
      
      {/* Skills section */}
 {filter === 'skill' && (
    
  <>
    <div className="flex overflow-x-auto hide-scrollbar mb-4 px-4 gap-8 justify-start sm:justify-start md:justify-start lg:justify-center">
      {startIndex > 0 && (
        <button
          onClick={goPrev}
          className="text-black hover:text-black transition-colors -mt-2"
          aria-label="Previous skills"
        >
          <IoIosArrowBack className="text-xl" />
        </button>
      )}
      {visibleSkills.map((skill) => (
        <button
          key={skill}
          onClick={() => handleSkillClick(skill)}
          className="relative pb-1 whitespace-nowrap group flex-shrink-0"
        >
          <span
            className={`text-sm sm:text-base transition-colors duration-300 ${
              selectedSkill.includes(skill)
                ? 'text-black font-semibold'
                : 'text-gray-400 group-hover:text-gray-600'
            }`}
          >
            {skill}
          </span>
          <span
            className={`absolute left-0 bottom-0 h-[2px] bg-primary rounded-full transition-all duration-300 ${
              selectedSkill.includes(skill) ? 'w-full opacity-100' : 'w-0 opacity-0'
            }`}
          />
        </button>
      ))}
      {startIndex + PAGE_SIZE < otherSkills.length && (
        <button
          onClick={goNext}
          className="text-black hover:text-black transition-colors -mt-2"
          aria-label="Next skills"
        >
          <IoIosArrowForward className="text-xl" />
        </button>
      )}
    </div>

   <div className=''>
     {!selectedSkill.includes('All') && selectedSkill.length > 0 && (
      <div className="flex flex-wrap gap-3 px-4 justify-start sm:justify-start md:justify-start lg:justify-center">
        {selectedSkill.map((skill) => (
          <span
            key={skill}
            className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-xs sm:text-sm font-medium"
          >
            {skill}
            <button
              onClick={() => handleSkillClick(skill)}
              aria-label={`Remove ${skill}`}
              className="hover:bg-primary/20 rounded-full p-0.5 transition-colors"
            >
              <IoClose className="text-sm" />
            </button>
          </span>
        ))}
      </div>
    )}
   </div>
  </>
 
)}
   
   


      <div
        className="mt-8 overflow-hidden mb-8 sm:mt-8 mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4 sm:gap-6 px-3"
        initial="hidden"
        animate="visible"
        variants={contentVariants}
        transition={{ duration: 1, ease: 'easeOut' }}
      > 
      <AnimatePresence>
        {filteredProjects.slice(0, visibleCount).map((project) => (
          <motion.div
            key={project.id}
            className="bg-white rounded-2xl shadow-image-border p-3 cursor-pointer"
            layout
            initial={{ opacity: 0, scale: 0.5}}
            animate={{ opacity: 1, scale: 1}}
            // exit={{ opacity: 0, scale: 0.5 }}
            transition={{ duration: 1 , ease:'easeOut' }}
            onClick={() => handleProjectClick(project.id)}
          >
            <img
              src={project.image}
              alt={project.title}
              className={`w-full h-70 sm:h-60 lg:h-72 rounded-[10px] sm:rounded-[10px] lg:rounded-[20px] xl:rounded-[10px] ${project.id === 7 || project.id === 8 || project.id === 9? 'object-cover' : 'object-contain'}`}
            />
            <h3 className="text-lg font-semibold text-primary">{project.title}</h3>
            <p className="text-xs mt-2 text-blue-400">{project.date}</p>
          </motion.div>
        ))}
         </AnimatePresence>
      </div>
      

      {visibleCount < filteredProjects.length && filteredProjects.length > 6 && (
        <motion.div className="text-center mt-8"
          initial="hidden"
          animate="visible"
          variants={contentVariants}
          transition={{ duration: 1, ease: 'easeOut' }}>
          <button
            onClick={handleLoadMore}
            className="bg-primary text-white px-4 py-2 rounded-md transition duration-300"
          >
            Load More
          </button>
        </motion.div>
      )}

    </div>
  );
}

export default CaseStudy;
